document.addEventListener("DOMContentLoaded", function () {
  let hiddenMobileItemList = null;
  let parentMobileMenuItemPanel = null;
  let subMobileMenuPanelBackButton = null;
  function updateArrows(container, scrollPosition, sliderWidth) {
    if (container) {
      if (scrollPosition == 0) {
        container
          .querySelector(".product-slider__prev")
          ?.setAttribute("disabled", "disabled");
      } else {
        container
          .querySelector(".product-slider__prev")
          ?.removeAttribute("disabled");
      }
      if (scrollPosition == Math.floor(sliderWidth)) {
        container
          .querySelector(".product-slider__next")
          ?.setAttribute("disabled", "disabled");
      } else {
        container
          .querySelector(".product-slider__next")
          ?.removeAttribute("disabled");
      }
    } else {
      if (scrollPosition == 0) {
        $(".product-slider__prev").attr("disabled", "disabled");
      } else {
        $(".product-slider__prev").attr("disabled", false);
      }
      if (scrollPosition == Math.floor(sliderWidth)) {
        $(".product-slider__next").attr("disabled", "disabled");
      } else {
        $(".product-slider__next").attr("disabled", false);
      }
    }
  }
  if ($(".product-slider__inner").length > 0) {
    updateArrows(
      null,
      $(".product-slider__inner").scrollLeft(),
      $(".product-slider__inner")[0].scrollWidth -
        $(".product-slider__inner").outerWidth()
    );

    // Product Slider
    $(".product-slider__inner").scroll(function () {
      var sliderWidth = this.scrollWidth - $(this).outerWidth();
      var scrollPosition = this.scrollLeft;

      updateArrows(
        this.closest(".custom-section__wrapper"),
        scrollPosition,
        sliderWidth
      );
    });

    $(".product-slider__prev").click(function () {
      $(this)
        .closest(".cm-featured-products")
        .find(".product-slider__inner")
        .animate(
          {
            scrollLeft: "-=500",
          },
          500
        );
    });
    $(".product-slider__next").click(function () {
      $(this)
        .closest(".cm-featured-products")
        .find(".product-slider__inner")
        .animate(
          {
            scrollLeft: "+=500",
          },
          500
        );
    });
  }
  const free_shipping_str = document.querySelector('.announcement_bar')?.getAttribute('freeshipping');
  if(free_shipping_str !== 'no') {
    const redrawAnnouncementBar = () => {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
          handleCartData(data);
        })
        .catch((error) => {
          console.error("Error fetching cart data:", error);
        });
    };
    const handleMoneyData = (money) => {
      let moneyStr = typeof money === "string" ? money : money.toString();
      if (moneyStr.indexOf(".") === -1) {
        let pointCount = Math.floor(moneyStr.length / 3);
        let rest = moneyStr.length % 3;
        if (rest === 0) {
          pointCount--;
        }
        for (let i = 0; i < pointCount; i++) {
          moneyStr =
            moneyStr.substring(0, moneyStr.length - 3 * (i + 1) - i) +
            "," +
            moneyStr.substring(moneyStr.length - 3 * (i + 1) - i);
        }
      } else {
        let pointCount = Math.floor((moneyStr.length - 3) / 3);
        let rest = (moneyStr.length - 3) % 3;
        if (rest === 0) {
          pointCount--;
        }
  
        for (let i = 0; i < pointCount; i++) {
          moneyStr =
            moneyStr.substring(0, moneyStr.length - 3 * (i + 1) - i - 3) +
            "," +
            moneyStr.substring(moneyStr.length - 3 * (i + 1) - i - 3);
        }
      }
      return moneyStr;
    };
    const handleCartData = (data) => {
      const announcementBar = document.querySelector(".announcement_bar");
      if (announcementBar) {
        let goal = parseFloat(announcementBar.getAttribute("goal"));
        const total_price = data.total_price / 100;
  
        if (goal <= total_price) {
          announcementBar.querySelector(".text").innerHTML =
            announcementBar.getAttribute("complete");
        } else {
          let messages;
          let diff_Price = goal - total_price;
          diff_Price.toFixed(2);
          const hightLightColor = announcementBar.getAttribute("highlightColor");
          let money_unit = announcementBar.getAttribute("money_format");
          if (total_price === 0) {
            messages = announcementBar.getAttribute("init").split("[price]");
            if (messages.length === 2) {
              announcementBar.querySelector(".text").innerHTML = `${
                messages[0]
              }<span class="price_show" style="color: ${hightLightColor};">${money_unit}${handleMoneyData(
                diff_Price
              )}</span>${messages[1]}`;
            } else {
              announcementBar.querySelector(".text").innerHTML = messages[0];
            }
          } else if (goal > total_price) {
            messages = announcementBar.getAttribute("progress").split("[price]");
            if (messages.length === 2) {
              announcementBar.querySelector(".text").innerHTML = `${
                messages[0]
              }<span class="price_show" style="color: ${hightLightColor};">${money_unit}${handleMoneyData(
                diff_Price.toFixed(2)
              )}</span>${messages[1]}`;
            } else {
              announcementBar.querySelector(".text").innerHTML = messages[0];
            }
          }
        }
      }
    };
    const observerConfig = {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    };
    let cartChanged = false;
    const observer = new MutationObserver((mutations) => {
      cartChanged = false;
      for (const mutation of mutations) {
        if (
          mutation.target.classList.contains("rebuy-cart__flyout-content") ||
          mutation.target.classList.contains("rebuy-cart__flyout-items") ||
          mutation.target.closest(".rebuy-cart__flyout-items")
        ) {
          if (!cartChanged) {
            redrawAnnouncementBar();
          }
          cartChanged = true;
        }
      }
    });
    let hTime = setInterval(() => {
      const cartDrawerItemContainer = document.querySelector(
        ".rebuy-cart__flyout-content"
      );
      if (cartDrawerItemContainer) {
        clearInterval(hTime);
        observer.observe(cartDrawerItemContainer, observerConfig);
      }
    }, 1000);
  }
  document
    .querySelector(".announcement_bar_close")
    ?.addEventListener("click", function () {
      this.parentElement.remove();
    });

  const controlMegaMenuPosition = () => {
    const megaMenuContainer = document.querySelector(".nav-bar__linklist");
    const megaMenuContainerInfo = megaMenuContainer.getBoundingClientRect();
    if (megaMenuContainer) {
      megaMenuContainer.querySelectorAll(".nav-bar__item").forEach((item) => {
        const megaMenu = item.querySelector(".mega-menu");
        if (megaMenu) {
          const navItemInfo = item.getBoundingClientRect();
          const megaMenuInfo = megaMenu.getBoundingClientRect();

          const overflowWidth =
            navItemInfo.left + megaMenuInfo.width - megaMenuContainerInfo.right;

          if (overflowWidth > 0) {
            //megamenu overflows navbar container on the right
            if (megaMenuContainerInfo.width < megaMenuInfo.width) {
              //when megamenu moves to left, it overflows navbar container on the left.
              megaMenu.style.maxWidth = `${megaMenuContainerInfo.width}px`;
              megaMenu.style.left = "0px";
            } else {
              megaMenu.style.left = `${
                navItemInfo.left - megaMenuContainerInfo.left - overflowWidth
              }px`;
            }
          } else {
            megaMenu.style.left = `${
              navItemInfo.left - megaMenuContainerInfo.left
            }px`;
          }

          megaMenu.style.top = `${navItemInfo.height + item.offsetTop}px`;
        }
      });
    }
  };
  window.onresize = controlMegaMenuPosition;
  controlMegaMenuPosition();

  document.querySelectorAll(".mobile-menu__nav-list-toggle").forEach((item) => {
    item.addEventListener("click", function () {
      const mobileMenu = this.closest(".mobile-menu_section__inner");
      const i = Array.from(
        mobileMenu.querySelectorAll(".mobile-menu__nav-list-toggle")
      ).indexOf(this);
      const subMobileMenus = this.closest(
        ".mobile-menu_section__inner"
      ).querySelectorAll(".sub-mobile-menu__section");
      if (subMobileMenus[i]) {
        subMobileMenus[i].classList.remove("d-none");
        subMobileMenuPanelBackButton = subMobileMenus[i].querySelector('.mobile-sub-menu__back-button');
        let hTime = setInterval(() => {
          clearInterval(hTime);
          subMobileMenus[i].classList.add("open");
        }, 10);
        hiddenMobileItemList = this.closest('.mobile-menu__nav-list');
        hiddenMobileItemList?.classList.add('d-none');
      }
    });
  });
  document.querySelectorAll(".mobile-sub-menu__back-button").forEach((item) => {
    item.addEventListener("click", function () {
      const subMobileMenu = this.closest(".sub-mobile-menu__section");
      if (subMobileMenu) {
        subMobileMenu.classList.remove("open");
        let hTime = setInterval(() => {
          clearInterval(hTime);
          subMobileMenu.classList.add('d-none');
        }, 320);
        hiddenMobileItemList?.classList.remove('d-none');
      }
    });
  });

  document.querySelectorAll(".mobile-menu_section__inner").forEach((item) => {
    if (
      item.querySelectorAll(".sub-mobile-menu__section").length == 0 &&
      item.querySelector(".mobile-menu__nav-list").length < 2
    ) {
      item.remove();
    }
  });

  document.querySelectorAll(".mobile-menu__nav-item").forEach((item) => {
    item.style.order = parseInt(item.getAttribute("order"));
    item.removeAttribute("order");
  });
  document.querySelectorAll(".mobile-menu__nav-list-item").forEach((item) => {
    const toggleButton = item.querySelector(".mobile-menu__nav-list-toggle");
    const navListItem = item.querySelector(".mobile-menu__nav-link");
    let text;
    let svg;
    if (toggleButton) {
      text = toggleButton.innerHTML;
      svg = toggleButton.querySelector("svg");
    } else if (navListItem) {
      text = navListItem.innerHTML;
    } else {
      return;
    }

    const i = text.indexOf(":mobile_order");
    if (i != -1) {
      const j = text.indexOf(":", i + 1);
      let order;
      if (toggleButton) {
        toggleButton.innerHTML = text.substring(0, i);
        if (j != -1) {
          toggleButton.innerHTML += text.substring(j);
        }
        if (svg) {
          toggleButton.innerHTML += svg.outerHTML;
        }
      } else if (navListItem) {
        navListItem.innerHTML = text.substring(0, i);
        if (j != -1) {
          navListItem.innerHTML += text.substring(j);
        }
      }
      if (j == -1) {
        order = parseInt(text.substring(i + 13));
      } else {
        order = parseInt(text.substring(i + 13, j));
      }
      item.style.order = order;
    }
  });
  document
    .querySelectorAll(".mobile-menu__sub-nav-list-item .sub_sub_link")
    .forEach((item) => {
      const text = item.innerHTML;
      const i = text.indexOf(":mobile_order");
      if (i != -1) {
        const j = text.indexOf(":", i + 1);
        let order;
        item.innerHTML = text.substring(0, i);
        if (j == -1) {
          order = parseInt(text.substring(i + 13));
        } else {
          order = parseInt(text.substring(i + 13, j));
          item.innerHTML += text.substring(j);
        }
        if (!item.parentElement.classList.contains("title")) {
          item.parentElement.style.order = order;
        }
      }
    });

  document
    .querySelectorAll(".mobile-menu__sub-nav-list-item")
    .forEach((item) => {
      let textItem = item.querySelector(".sub_sub_link");
      if (textItem) {
        const text = textItem.innerHTML;
        if (text.indexOf("only_desktop") != -1) {
          item.remove();
        } else {
          const replacedText = text.replace(":only_mobile", "");
          const i = replacedText.indexOf(":mobile_setting");
          const j = replacedText.indexOf(":", i + 1);
          if (i != -1) {
            const order = parseInt(replacedText.substring(i + 15));
            item.style.order = order;

            textItem.innerHTML = replacedText.substring(0, i);
            if (j != -1) {
              textItem.innerHTML += replacedText.substring(j);
            }
            const subMobileNavContainer = item.parentElement;
            const futureParent = item
              .closest(".mobile-menu_section__inner")
              .querySelector(".mobile-menu__nav-list");
            item.remove();
            futureParent.appendChild(item);
            if (subMobileNavContainer.children.length < 2) {
              subMobileNavContainer.remove();
            }
          } else {
            textItem.innerHTML = replacedText;
          }
        }
      }
    });
  document.querySelectorAll(".mobile-menu__nav-list-toggle").forEach((item) => {
    const itemHtml = item.innerHTML;
    const parent = item.parentElement;
    if (itemHtml.indexOf("only_desktop") != -1) {
      item.remove();
      if (parent.children.length < 2) {
        parent.remove();
      }
    } else {
      item.innerHTML = itemHtml.replace(":only_mobile", "");
    }
  });
  document.querySelectorAll(".mobile-menu__nav-link").forEach((item) => {
    const parent = item.parentElement;
    const itemHtml = item.innerHTML;

    if (itemHtml.indexOf("only_desktop") != -1) {
      item.remove();
      if (parent.children.length < 2) {
        parent.remove();
      }
    } else {
      item.innerHTML = itemHtml.replace(":only_mobile", "");
    }
    item.addEventListener('click',()=>{
      parentMobileMenuItemPanel = item.closest('.mobile-menu__panel');
      parentMobileMenuItemPanel?.classList.add('overflow-hidden');
    });
  });

  document.querySelectorAll(".mega-menu__title").forEach((item) => {
    const text = item.innerHTML;
    const i = text.indexOf(":");
    if (i != -1) {
      item.innerHTML = text.substring(0, i);
    }
  });
  document.querySelectorAll(".mega-menu__link").forEach((item) => {
    const text = item.innerHTML;
    const i = text.indexOf(":");
    if (i != -1) {
      item.innerHTML = text.substring(0, i);
    }
  });
  document.querySelectorAll(".nav-dropdown__link").forEach((item) => {
    const text = item.innerHTML;
    const i = text.indexOf(":");
    if (i != -1) {
      item.innerHTML = text.substring(0, i);
    }
  });
  document.querySelector('.header__mobile-nav-toggle').addEventListener('click',()=>{
    subMobileMenuPanelBackButton?.click();
    document.documentElement.classList.toggle('overflow-hidden');
  });
  const isPad = () => {
    const userAgent = navigator.userAgent;
    if (
      /iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) &&
      navigator.maxTouchPoints > 1
    ) {
      return true;
    }
    if (/(windows|mac)/i.test(userAgent)) {
      return false;
    }

    // Check if the user agent string contains "linux"
    if (/linux/i.test(userAgent)) {
      return false;
    }
  };
  if (isPad()) {
    document
      .querySelector(".flex-mode2")
      ?.closest(".mega-menu")
      ?.classList.add("pb-70");
  }

  Fancybox.bind("[data-fancybox]",{
      type: "image",
    gallery: {
      enabled: true
    },
    image: {
      titleSrc: function (item) {
        return (
          item.el.find(".title").html() +
          `<small>${item.el.find(".author").html()}</small>`
        );
      }
    }
  });
});
